import Vue from 'vue';
import vuei18n from '@/i18n';
import store from '@/store/store';
import Basket from '@/views/Basket';
import Interrupt from '@/views/Interrupt';
import Donation from '@/views/Donation';
import Payment from '@/views/Payment.vue';
import Confirmation from '@/views/Confirmation';

import ScreenContextService from '@/api/services/ScreenContextService';

import VueRouter from 'vue-router';

Vue.use(VueRouter);

function handleContext(contextLoader) {
  return async (to, from, next) => {
    try {
      to.params.context = await contextLoader({ orderId: store.getters?.getOrderId });
    } catch (error) {
      if (store?.hasModule?.('navigation')) {
        await store.dispatch('navigation/handleError', error);
      }

      await store.dispatch(
        'notification/notifyFailure',
        {
          message: error?.debugMessage || error?.message,
          options: { dismissSecs: -1 },
        },
        { root: true }
      );
    } finally {
      next();
    }
  };
}

const routes = [
  {
    path: '/basket',
    alias: '/',
    name: 'Basket',
    component: Basket,
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Basket,
    meta: { skipToCheckout: true },
    beforeEnter: async function (to, from, next) {
      try {
        await store.dispatch("order/fetchOrder", store.getters.getOrderId);
      } finally {
        next();
      }
    },
  },
  {
    path: '/interrupt',
    name: 'Interrupt',
    component: Interrupt,
  },
  {
    path: '/donation',
    name: 'Donation',
    component: Donation,
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    props: true,
    beforeEnter: handleContext(ScreenContextService.fetchOrderPaymentScreenContext),
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation,
  },
  {
    path: '/tos',
    name: 'TermsOfService',
    beforeEnter: () => {
      window.open(`${window.BASE_URL}/tos`, '_blank');
    },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    beforeEnter: () => {
      window.open(`${window.BASE_URL}/privacy-policy`, '_blank');
    },
  },
  {
    path: '/logout',
    name: 'SyfLogout',
    beforeEnter: () => {
      window.location.href = `${window.BASE_URL}/logout?baseUrl=${window.BASE_URL}`;
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: global.APP_PATH || process.env.VUE_APP_PATH,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (store?.hasModule?.('navigation')) {
    store.dispatch('navigation/start');
  }

  const pageTitle = vuei18n.messages[store.getters.getLocale.replace('_', '-')]?.meta?.title?.[to.name] || '';
  document.title = pageTitle ? `DocuPet - ${pageTitle}` : 'DocuPet';
  next();
});

router.afterEach(() => {
  if (store?.hasModule?.('navigation')) {
    store.dispatch('navigation/stop');
  }
});

export default router;
